import Login from "./pages/login/Login";
import Home from "./pages/home/Home";
import Parent from "./pages/parent/Parent";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import AddLesson from "./pages/parent/AddLesson";
// import "antd/dist/antd.css";

const App = () => {
  return (
    <Router>
      <div>
        <Switch>
          <PrivateRoute path="/parent/addLesson">
            <AddLesson />
          </PrivateRoute>
          <PrivateRoute path="/parent">
            <Parent />
          </PrivateRoute>
          <PrivateRoute path="/dashboard">
            <Home />
          </PrivateRoute>
          <Route path="/login">
            <Login />
          </Route>

          <Route exact path="/">
            <Redirect to="/dashboard" />
          </Route>
        </Switch>
      </div>
    </Router>
  );
};

function PrivateRoute({ children, ...rest }) {
  const token =
    localStorage.getItem("token") || localStorage.getItem("parent-token");
  return (
    <Route
      {...rest}
      render={({ location }) =>
        token ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}

function ParentRoute({ children, ...rest }) {
  const token = localStorage.getItem("parent-token");
  return (
    <Route
      {...rest}
      render={({ location }) =>
        token ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}

export default App;
